export enum TaskType {
    GENERAL = 'GENERAL',
    BALANCE_SHEET = 'BALANCE_SHEET',
    INCOME_STATEMENT = 'INCOME_STATEMENT',
}
